// lib/services/authService.js
import api, { apiWithAuth } from "@/lib/axios";

export async function fetchLogin({ email, password }) {
  try {
    const payload = {
      email,
      password,
    };

    const { data } = await api.post("/auth/login", payload);
    console.log(data);
    return data; // IMPORTANTÍSIMO: devolver el body, no el AxiosResponse
  } catch (err) {
    // Log útil para ver por qué tu backend devuelve 4xx/5xx
    const status = err?.response?.status;
    const body = err?.response?.data;
    console.error("[fetchLogin] error:", status, body);
    return null;
  }
}

export async function fetchstatus(token) {
  try {
    const { data } = await apiWithAuth.get("/auth/status", token);
    return data;
  } catch (err) {
    const status = err?.response?.status;
    const body = err?.response?.data;
    console.error("fetchStatus error: ", status, body);
    return null;
  }
}

export async function fetchRegister(
  { email, firstName, lastName, phone, password },
  invitationToken = null,
) {
  try {
    const payload = { email, firstName, lastName, phone, password };
    const url = invitationToken
      ? `/auth/register?invitationToken=${invitationToken}`
      : "/auth/register";
    const { data } = await api.post(url, payload);
    return data;
  } catch (err) {
    const status = err?.response?.status;
    const body = err?.response?.data;
    console.error("[fetchRegister] error:", status, body);
    return null;
  }
}
